"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartTypeDescriptionSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var get_specs_1 = require("./get_specs");
exports.getChartTypeDescriptionSelector = re_reselect_1.default([get_specs_1.getSeriesSpecsSelector], function (specs) {
    var seriesTypes = new Set();
    specs.forEach(function (value) { return seriesTypes.add(value.seriesType); });
    var chartSeriesTypes = seriesTypes.size > 1 ? "Mixed chart: " + __spread(seriesTypes).join(' and ') + " chart" : __spread(seriesTypes) + " chart";
    return chartSeriesTypes;
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_chart_type_description.js.map